import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { colors, palette } from "../styles/design-tokens";
import { readBrandColor } from "./partnerBranding";

export function useThemeColorByPathname() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Theme Studio's App background (a hex partnerTheme writes on <html>) paints the
    // browser bar too; a meta tag cannot read a CSS var.
    const page = document.documentElement.style.getPropertyValue("--zv-canvas").trim() || palette["gray-100"];
    let newColor: string = page;
    switch (pathname) {
      case "/onboarding":
        newColor = readBrandColor("primary-light", colors.brand.primaryLight1);
        break;
      default:
        newColor = page;
    }

    // Remove any existing meta tags
    const existing = document.querySelector("meta[name='theme-color']");
    if (existing) existing.remove();

    // Create a brand new meta tag (forces repaint)
    const meta = document.createElement("meta");
    meta.setAttribute("name", "theme-color");
    meta.setAttribute("content", newColor);
    document.head.appendChild(meta);

    // Force reflow
    void document.body.offsetHeight;

    console.log("Theme color updated to:", newColor);
  }, [pathname]);
}
